// router/index.js
import {createRouter, createWebHistory} from 'vue-router'
import About from '@/views/About.vue'
import template from '@/views/template.vue'
import thirdLogin from '@/views/thirdLogin.vue'
import Layout from '@/components/layout/DefaultLayout.vue'
import NotFoundComponent from '@/components/errortips/NotFoundComponent.vue'
import login from "@/views/Login";
import {nprogressStart,nprogressClose} from "@/components/nprogress/nprogress";
import watermark from "@/components/watermark/watermark";
import {getCurrentYYMMDD} from "@/utils/dateUtils";
import {isWi5Domain} from "@/utils/domain";


const sysName = () => {
    return isWi5Domain() ? "BATTERY INFORMATION" : "WINPEX";
}
const watermarkText = ()=>{
    return (localStorage.getItem("loginUserStore")===null?"":getCurrentYYMMDD()+JSON.parse(localStorage.getItem("loginUserStore")).sessionInfo.realname);
}


const routes = [
    {
        path: '/',
        component: login,
        meta: {
            title: '登录',
            keepAlive: true // 不需要缓存
        }
    },
    {
        path: '/about',
        component: About,
    },
    {
        path: '/template',
        component: template,
    },
    {
        path: '/thirdLogin',
        component: thirdLogin,
        meta:{
            permissionName: "三方授权登录中...",
            needLogin: false
        }
    },
    {
        path: '/phone/batteryDpiView',
        component: () => import('@/views/phone/batteryDpiView.vue'),
        meta:{
            permissionName: "电池产品信息",
            needLogin: false
        }
    },
    {
        path: '/pb/:id',
        component: () => import('@/views/phone/batteryDpiView.vue'),
        meta:{
            permissionName: "电池产品信息",
            needLogin: false
        }
    },
    {
        path: '/phone/batteryP2View',
        component: () => import('@/views/phone/batteryP2View.vue'),
        meta:{
            permissionName: "硕乐电池产品信息",
            needLogin: false
        }
    },
    {
        path: '/p2/:id',
        component: () => import('@/views/phone/batteryP2View.vue'),
        meta:{
            permissionName: "硕乐电池产品信息",
            needLogin: false
        }
    },
    {
        path: '/index',
        component: Layout, // 配置该属性将用该组件相关的模版
        meta:{
            permissionName: "首页"
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFoundComponent
    }
]

const router = createRouter({
    history: createWebHistory(),
    mode:'history',
    routes
})

// 读取路由信息
if(localStorage.getItem("loginUserStore")){
    let dynamicRoutes = JSON.parse(localStorage.getItem("loginUserStore")).dynamicRoutes;
    //console.info(dynamicRoutes)
    dynamicRoutes.forEach(route => {
        const permission = {
            path: route.path,
            component:  () => import('@/views'+route.path+'.vue'),
            meta:{
                permissionId: route.meta.permissionId,
                permissionName: route.meta.permissionName,
                icon: route.meta.icon,
                permissionParent: route.meta.permissionParent,
                permissionType: route.meta.permissionType,
            }
        }
        router.addRoute(permission)
    })
}

// 跳转之前执行
router.beforeEach(async (to, from, next) => {
    if(to.path !== '/index' || to.path !== '/'){
        nprogressStart();
    }
    // 判断用户是否已经登录
    if (localStorage.getItem("loginUserStore")) {
    // 登录用户可以访问所有路由
        next()
    } else {
        // 未登录用户只能访问部分路由
        if (to.path === '/' || to.path === '/register' || to.meta.needLogin === false) {
            next()
        } else {
            next('/?redirect='+to.path)
        }
    }

    if (to.meta.permissionName) { // 判断是否有标题
        //document.title = to.meta.permissionName + "-" + sysName ;
        document.title = sysName() ;
    }

    if (to.meta.permissionName === "首页" || to.meta.permissionName === undefined) { // 判断是否有标题
        document.title = sysName() ;
    }
    if(from.path === "/"){
        // 从登录页进入,并且不是在iframe中
        if (self === top){
            watermark.set(watermarkText());
        }

    }
});

router.afterEach((to) => {
    if(to.path !== '/index' || to.path !== '/'){
        nprogressClose();
    }
    if(to.path === "/index"){
        // 返回到home页面
        watermark.set(watermarkText());
    }
});

export default router
